export default __webpack_public_path__ + "static/media/Telco.817f8df2.svg";